import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Sluzby from './pages/Sluzby'; // Added import for Sluzby
import Strategie from './pages/Strategie';
import Web from './pages/Web';
import Vykon from './pages/Vykon';
import Kontakt from './pages/Kontakt';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="sluzby" element={<Sluzby />} /> {/* Changed to Sluzby component */}
          <Route path="strategie" element={<Strategie />} />
          <Route path="web" element={<Web />} />
          <Route path="vykon" element={<Vykon />} />
          <Route path="kontakt" element={<Kontakt />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
